import { useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBookAndPageNumberUIContext } from "../BookAndPageNumberUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, date, dateEnd, sectionId, studentId, studentNumber, bookCount, pageNumberCount } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  bookCount = bookCount === "" ? null : bookCount;
  pageNumberCount = pageNumberCount === "" ? null : pageNumberCount;
  const newQueryParams = { ...queryParams };
  const filter = { date, dateEnd, sectionId, studentId, studentNumber, bookCount, pageNumberCount };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function BookAndPageNumberFilter() {
  // Book And Page Number UI Context
  const bookAndPageNumberUIContext = useBookAndPageNumberUIContext();
  const bookAndPageNumberUIProps = useMemo(() => {
    return {
      term: bookAndPageNumberUIContext.term,
      date: bookAndPageNumberUIContext.date,
      dateEnd: bookAndPageNumberUIContext.dateEnd,
      sectionId: bookAndPageNumberUIContext.sectionId,
      studentId: bookAndPageNumberUIContext.studentId,
      queryParams: bookAndPageNumberUIContext.queryParams,
      setQueryParams: bookAndPageNumberUIContext.setQueryParams
    };
  }, [bookAndPageNumberUIContext]);

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookAndPageNumberUIProps.term, bookAndPageNumberUIProps.date, bookAndPageNumberUIProps.dateEnd, bookAndPageNumberUIProps.sectionId, bookAndPageNumberUIProps.studentId]);
  
  
  const applyFilter = (values) => {
    values.term = bookAndPageNumberUIProps.term;
    values.date = bookAndPageNumberUIProps.date;
    values.dateEnd = bookAndPageNumberUIProps.dateEnd;
    values.sectionId = bookAndPageNumberUIProps.sectionId;
    values.studentId = bookAndPageNumberUIProps.studentId;
    const newQueryParams = prepareFilter(bookAndPageNumberUIProps.queryParams, values);
    if (!isEqual(newQueryParams, bookAndPageNumberUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      bookAndPageNumberUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        studentNumber: "",
        bookCount: "",
        pageNumberCount: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="studentNumber"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="bookCount"
                min={1}
                placeholder="Kitap Sayısı"
                onBlur={handleBlur}
                value={values.bookCount}
                onChange={(e) => {
                  setFieldValue("bookCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kitap Sayısı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="pageNumberCount"
                min={1}
                placeholder="Sayfa Sayısı"
                onBlur={handleBlur}
                value={values.pageNumberCount}
                onChange={(e) => {
                  setFieldValue("pageNumberCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sayfa Sayısı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}